export function getPriInputDlgSession() {
    return (
        window['procMain'] &&
        window['procMain'].getPriInputDlgSession &&
        window['procMain'].getPriInputDlgSession()
    );
}

export function getCompressedFieldDataSet() {
    return (
        window['procMain'] &&
        window['procMain'].getCompressedFieldDataSet &&
        window['procMain'].getCompressedFieldDataSet()
    );
}

export function excecutePrintLabels() {
    return (
        window['procMain'] &&
        window['procMain'].excecutePrintLabels &&
        window['procMain'].excecutePrintLabels()
    );
}

export function getText(field: number, inputIdx: number) {
    return (
        window['procMain'] &&
        window['procMain'].getText &&
        window['procMain'].getText(field, inputIdx)
    );
}

export function getFieldOperator(field: number) {
    return (
        window['procMain'] &&
        window['procMain'].getFieldOperator &&
        window['procMain'].getFieldOperator(field)
    );
}

export function setText(value: string, field: number, inputIdx: number) {
    window['procMain'] &&
        window['procMain'].setText &&
        window['procMain'].setText(value, field, inputIdx);
}

export function formZoom(field: number, inputIdx: number, mode: string) {
    window['procMain'] &&
        window['procMain'].formZoom &&
        window['procMain'].formZoom(field, inputIdx, mode);
}

export function endProc() {
    window['procMain'] && window['procMain'].endProc && window['procMain'].endProc();
}

export function selectProc(elementId) {
    window['procMain'] && window['procMain'].selectProc && window['procMain'].selectProc(elementId);
}

export function getConnection() {
    return (
        window['procMain'] && window['procMain'].getConnection && window['procMain'].getConnection()
    );
}

export function setExcelTemplate(template: string) {
    window['procMain'] &&
        window['procMain'].setExcelTemplate &&
        window['procMain'].setExcelTemplate(template);
}

export function openTemplateDesign(isTemplate: boolean, hasWordTemplates: boolean) {
    window['procMain'] &&
        window['procMain'].openTemplateDesign &&
        window['procMain'].openTemplateDesign(isTemplate, hasWordTemplates);
}

export function isDebugMode() {
    return window['procMain'] && window['procMain'].isDebugMode && window['procMain'].isDebugMode();
}

export function closeReportsDlg() {
    return (
        window['procMain'] &&
        window['procMain'].closeReportsDlg &&
        window['procMain'].closeReportsDlg()
    );
}

export function procClientContinue(paramsString: string) {
    return window['procMain']?.procClientContinue?.(paramsString);
}
